<template>
  <div>
    <div :class="variant === 'cookies' ? 'cookies-page' : 'rules-page px-3'">
      <div class="container" :class="{ 'pt-4': flush }">
        <template v-if="flush">
          <slot />
        </template>
        <div class="row" v-else-if="variant === 'cookies'">
          <div class="col-12 my-5">
            <slot />
          </div>
        </div>
        <div class="row" v-else>
          <h1 v-if="title" class="mt-md-5 mb-4 mb-md-0 text-center w-100" v-html="title"></h1>
          <template v-if="rawColumns">
            <slot />
          </template>
          <div v-else :class="colClass">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <ContactForm v-if="showContactForm" />
  </div>
</template>

<script>
import ContactForm from "@/components/shared/ContactForm";

export default {
  name: "LegalPage",
  components: { ContactForm },
  props: {
    // 'cookies' -> .cookies-page wrapper (container > row > col-12 my-5)
    // 'rules'   -> .rules-page wrapper (container > row > h1 + column)
    variant: {
      type: String,
      default: 'rules'
    },
    // rendered as the row's <h1>, only used for the 'rules' variant
    title: {
      type: String,
      default: null
    },
    colClass: {
      type: String,
      default: 'col-12 col-md-8 py-md-5 px-4 mx-auto'
    },
    // slot content provides its own column div(s) directly inside the row (e.g. a 2-column layout)
    rawColumns: {
      type: Boolean,
      default: false
    },
    // skip the row/column nesting entirely (container gets pt-4 instead)
    flush: {
      type: Boolean,
      default: false
    },
    showContactForm: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<!-- unscoped: these classes are only used by legal/static pages rendered through
     this wrapper, and the slotted content below needs to be reachable without ::v-deep -->
<style lang="sass">
.cookies-page
  padding-top: 85px
  background: #2D323A

  h1
    @media (max-width: 768px)
      font-size: 30px

  h3
    font-size: 22px

  p
    font-size: 16px
    font-weight: 400

  a
    color: var(--blue)

.rules-page
  padding-top: 85px
  background: #2D323A

  h1
    @media (max-width: 768px)
      font-size: 30px

  .rule
    margin-bottom: 40px

    h3
      font-size: 22px

    p
      font-size: 16px
      font-weight: 400
</style>
